module.exports = __webpack_public_path__ + "static/bank@3x-59a95e78f4e2832090f4dd61979cf548.png";